import axios from '../config/axios'

const API_BASE = '/vehicle-contracts'

const vehicleContractService = {
  // Get all contracts
  getAll: (filters = {}) => {
    return axios.get(API_BASE, { params: filters })
  },

  // Get single contract
  getOne: (contractId) => {
    return axios.get(`${API_BASE}/${contractId}`, {
      params: {
        include_daily_trips: 'true',
        include_payments: 'true'
      }
    })
  },

  // Create new contract
  create: (data) => {
    return axios.post(API_BASE, data)
  },

  // Update contract
  update: (contractId, data) => {
    return axios.put(`${API_BASE}/${contractId}`, data)
  },

  // Delete contract
  delete: (contractId) => {
    return axios.delete(`${API_BASE}/${contractId}`)
  },

  // Download invoice
  downloadInvoice: (contractId, includeDailyTrips = false) => {
    return axios.get(`${API_BASE}/${contractId}/invoice/download`, {
      params: { include_daily_trips: includeDailyTrips ? 'true' : 'false' },
      responseType: 'blob'
    })
  }
}

export default vehicleContractService
